@if (showAlerta === true) {
  <div class="body-alert-modal">
    <div class="div-modal-atencao" style="width: 539px;height: 387px">
      <div class="row" style="position: absolute;right: 40px;top: 15px;">
        <button class="btn-icon-close"
          (click)="fechouAlerta()"
          aria-label="Fechar alerta">
          <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
        </button>
      </div>
      <div class="div-alerta-padrao">
        <img src="/assets/img/alerta-padrao.png" alt="Alerta" height="90px">
        <h1>{{tituloAlerta}}</h1>
        <p>{{descricaoAlerta}}</p>
        <div>
          <button class="botao-padrao bg-botao-outline" (click)="fechouAlerta()" id="cancelaAlertaPadrao">CANCELAR</button>
          <button class="botao-padrao bg-botao-confirmar" (click)="confirmaAlerta()" id="confirmAlertaPadrao">CONFIRMAR</button>
        </div>
      </div>
    </div>
  </div>
}
